import { FC, Fragment } from "react";
import { Button, Menu, Theme } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { CommitmentsHeaderProviderSelectItem } from "./CommitmentsHeaderProviderSelectItem";
import { ProviderIcon } from "@/components/common/ProviderIcon";
import { ProviderType } from "@/services/cloudchipr.api";
import { UseMenuHookOpenMenu } from "@/utils/hooks/useMenu.hook";

interface NavItem {
  provider: ProviderType;
  orgId: string;
  org: string;
}

interface CommitmentsHeaderProviderSelectProps {
  provider: ProviderType;
  selectedOrgName?: string;
  open: boolean;
  anchor: HTMLElement | null;
  openMenu: UseMenuHookOpenMenu;
  closeMenu: () => void;
  filteredNavItems: NavItem[];
  onCommitmentClick(provider: ProviderType): void;
}

export const CommitmentsHeaderProviderSelect: FC<
  CommitmentsHeaderProviderSelectProps
> = ({
  provider,
  selectedOrgName,
  open,
  anchor,
  openMenu,
  closeMenu,
  filteredNavItems,
  onCommitmentClick,
}) => {
  return (
    <Fragment>
      <Button
        variant="text"
        color="tertiary"
        sx={buttonStyles}
        onClick={openMenu}
        startIcon={<ProviderIcon provider={provider} />}
        endIcon={open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
      >
        {`${selectedOrgName ?? ""} Commitments`}
      </Button>
      <Menu
        anchorEl={anchor}
        open={open}
        onClose={closeMenu}
        slotProps={slotProps}
      >
        {filteredNavItems?.map((item) => (
          <CommitmentsHeaderProviderSelectItem
            key={item.orgId + item.provider}
            provider={item.provider}
            orgId={item.orgId}
            title={`${item.org} Commitments`}
            onCommitmentClick={onCommitmentClick}
          />
        ))}
      </Menu>
    </Fragment>
  );
};

const buttonStyles = {
  alignSelf: "center",
  color: "grey.700",
  ":hover": {
    bgcolor: (theme: Theme) => theme.palette.action.hover,
  },
  "& .MuiButton-endIcon": {
    ml: 0.5,
  },
};

const slotProps = {
  paper: {
    sx: {
      width: 300,
    },
  },
};
